import useScreenShots from '@/hooks/useScreenShots';
import { Box, Grid, Image } from '@chakra-ui/react';

interface Props {
	gameId: string;
}

const GameScreenShots = ({ gameId }: Props) => {
	const { data: screenShots, error, isLoading } = useScreenShots(gameId);

	if (isLoading) return null;

	if (error) throw error;

	return (
		<Grid templateColumns={{ base: '1fr', lg: 'repeat(4, 1fr)' }} gap={4}>
			{screenShots?.map((item) => (
				<Box key={item?.id} textAlign="center" color="white">
					<Box height="180px" overflow="hidden">
						<Image
							src={item?.image}
							alt={String(item.id)}
							objectFit="cover"
							width="100%"
							height="100%"
						/>
					</Box>
				</Box>
			))}
		</Grid>
	);
};

export default GameScreenShots;
